<template>
  <div class="app">
    <router-view />
    <img src="../../assets/dragging.png" id="dragImage" />
  </div>
</template>
<script>
import db from '@/plugin/db'
export default {
  name: 'PIndexApp',
  data () {
    return {
      observer: null,
      firedNum: 0,
      oldHeight: 0,
      timer: null
    }
  },
  created () {
    this.initParams()
  },
  mounted () {
    this.bindEvent()
    this.resizeWindow()
  },
  methods: {
    bindEvent () {
      // 绑定C健 新建
      document.addEventListener('keydown', event => {
        let e = event || window.event
        if (e.ctrlKey || e.metaKey || e.keyCode !== 67) {
          return false
        }
        if (document.activeElement.tagName.toUpperCase() === 'BODY' && window.parent.document.querySelectorAll('.create-task-by-dig').length === 0) {
          this.$postMessage.createTask()
        }
      })
    },
    resizeWindow () {
      let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
      let element = document.querySelector('.app')
      this.observer = new MutationObserver((mutationList) => {
        let height = parseInt(window.getComputedStyle(element).getPropertyValue('height'))
        if (height === this.oldHeight) {
          return
        }
        clearTimeout(this.timer)
        this.oldHeight = height
        this.timer = setTimeout(() => {
          try {
            window.parent.document.querySelector('#workPlatIframe').style.height = (height + 10) + 'px'
          } catch (e) { }
        }, 500)
      })
      this.observer.observe(element, {
        attributes: true,
        attributeFilter: ['style'],
        attributeOldValue: true,
        characterData: true,
        subtree: true
      })
    },
    initParams () {
      this.$store.commit('USER_INITIAL', {
        userId: db.ls.get('userid'), // 兼容ilaw临时字段，请勿在vue项目中使用
        id: db.ls.get('userid'),
        name: db.ls.get('name'),
        pic: db.ls.get('pic'),
        pinyin: db.ls.get('pinyin'),
        userPic: db.ls.get('pic') // 兼容ilaw临时字段，请勿在vue项目中使用
      })
    }
  },
  beforeDestroyed () {
    if (this.observer) {
      this.observer.disconnect()
      this.observer.takeRecords()
      this.observer = null
    }
  }
}
</script>
<style lang="stylus">
#dragImage
  position fixed
</style>
